<template>
<!-- <transition name="slide"> -->
  <div 
    v-if="postArray.length > 0"
    id="stream-container">
    <Stream v-bind:postArray="postArray" />
    <!-- <Footer/> -->
  </div>
<!-- </transition> -->
</template>


<script>

import Stream from '../components/stream'
// create a seo description for the page
// const desc = 'Founded by Yue-Shin Lin and Dennis Helbig, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.'
const desc = "Onimo Studios ist ein Design-Kollektiv in Graz und bietet die perfekte Verbindung aus einzigartiger Grafik und kreativem Webdesign. Unser Fokus liegt auf modernen, nutzerfreundlichen Websites und maßgeschneiderten Printmedien Unsere Grafikdesign-Experten gestalten nicht nur beeindruckende Logos, sondern auch wirkungsvolle Marketingmaterialien für eine unverwechselbare Markenpräsenz. Onimo Studios setzt zudem auf Suchmaschinenoptimierung (SEO), um Ihre digitale Sichtbarkeit zu maximieren. Vertrauen Sie Onimo Studios, um Ihre Online- und Print-Präsenz zu optimieren. Kontaktieren Sie uns jetzt für kreative Lösungen, die Ihren Erfolg auf allen Ebenen steigern!"

export default {
  name: 'Projects',

  metaInfo: {
    title: 'Our Projects',
    // if no subcomponents specify a metaInfo.title, this title will be used
    meta: [
      
      { vmid: 'og:title', name: 'og:title', content: 'Our Projects | ONIMO studios' },
      { vmid: 'description', name: 'description', content: desc },
      { vmid: 'og:description', name: 'og:description', content: desc },
   
      { vmid: 'og:image', name: 'og:image', content: 'https://onimo-studios.com/fb-banner.png' },
      { vmid: 'og:url', name: 'og:url', content: 'https://onimo-studios.com/' },
    ]
  },

  props:{
    postArray: Array,
    loading: Boolean,
  },

  components: {
    Stream,
  },

  methods: {
    createSchema(){
      const script = document.createElement('script');
      script.id = 'schema';
      script.type = 'application/ld+json';
      script.innerHTML = `
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "ONIMO studios",
          "url": "https://onimo-studios.com/",
          "logo": "https://onimo-studios.com/fb-banner.png",
          "award": "fee-Award 2022",
          "sameAs": [
            "https://www.instagram.com/onimostudios/",
            "https://www.facebook.com/onimostudios/"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Sigmundstadl 1",
            "addressLocality": "Graz",
            "addressRegion": "Styria",
            "postalCode": "8020",
            "addressCountry": "AT"
          },
          "location": {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Sigmundstadl 1",
              "addressLocality": "Graz",
              "addressRegion": "Styria",
              "postalCode": "8020",
              "addressCountry": "AT"
            }
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "5",
            "ratingCount": "2",
            "ratingValue": "5"
          },
          "email": "mail@onimo-studios.com",
          "founders": [
            {
              "@type": "Person",
              "name": "Yue-Shin Lin",
              "sameAs": "https://linyueshin.com/"
            },
            {
              "@type": "Person",
              "name": "Dennis Helbig",
              "sameAs": "https://dennishelbig.dev/"
            }
          ],
          "members": [
            {
              "@type": "Person",
              "name": "Yue-Shin Lin",
              "sameAs": "https://linyueshin.com/"
            },
            {
              "@type": "Person",
              "name": "Dennis Helbig",
              "sameAs": "https://dennishelbig.dev/"
            },
            {
              "@type": "Person",
              "name": "Margit Steidl",
              "sameAs": "https://www.studiolo-m.com/"
            },
            {
              "@type": "Person",
              "name": "Katharina Schwarz",
              "sameAs": "https://www.behance.net/katharinaschwarz/"
            },
            {
              "@type": "Person",
              "name": "Lilly Jagl",
              "sameAs": "https://www.instagram.com/lillyjagl/"
            }
          ],
          "keywords": "branding, websites, magazines, illustrations, photography, videography, copywriting, web, development, design, coding, graz, steiermark, studios studio",
          "foundingDate": "2016",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "inquiries",
            "email": "mail@onimo-studios.com"
          },
          "slogan": "Design and Coding for Individual and Forward Thinking People",
          "image": "https://onimo-studios.com/fb-banner.png",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Branding",
                  "description": "We create a unique and memorable brand identity that will make you stand out from the crowd."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Websites",
                  "description": "We design and develop websites that are tailored to your needs and goals."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Magazines",
                  "description": "We create magazines that are visually appealing and easy to read."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Illustrations",
                  "description": "We create unique and eye-catching illustrations."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Photography",
                  "description": "We create photos that are visually appealing and tell a story."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Videography",
                  "description": "We create videos that are visually appealing and tell a story."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Copywriting",
                  "description": "We create texts that are tailored to your needs and goals."
                }
              }
            ]
          },
          "hasPart": [
            {
              "@type": "CreativeWork",
              "name": "THE CAKE ESCAPE",
              "description": "THE CAKE ESCAPE is a virtual band with five animated members. With lyrics about feminism and anti-racism, the band sings in different languages for diversity and equality",
              "url": "https://thecakeescape.com/",
              "creator": {
                "@type": "Person",
                "name": "Yue-Shin Lin",
                "sameAs": "https://linyueshin.com/"
              },
              "isFamilyFriendly": "true",
              "keywords": "music, band, virtual, animation, feminism, anti-racism, diversity, equality",
              "award": "fee-Award 2022",
              "thumbnailUrl": "https://backend.onimo-studios.com/wp-content/uploads/2023/03/thecakeescape_01_©ONIMOstudios_RGB.jpg",
              "sameAs": [
                "https://www.instagram.com/thecakeescape.official/",
                "https://www.facebook.com/thecakeescape.official/",
                "https://www.youtube.com/@thecakeescape"
              ]
            }
          ]
        }`;
      document.head.appendChild(script);
    }
  },

  created(){
    this.createSchema()
  },

  beforeDestroy(){
    const script = document.getElementById('schema');
    document.head.removeChild(script);
  }
}


</script>



<style lang="scss">
  @import '../scss/misc.scss';

  #stream-container #stream{
    @include content-bottom();
  }
</style>